import OktaAuth from '@okta/okta-auth-js';

import { SSO_OKTA_CLIENT_ID, SSO_OKTA_ISSUER } from 'common/auth/sso/okta.config';

const oktaAuth = new OktaAuth({
    issuer: SSO_OKTA_ISSUER,
    clientId: SSO_OKTA_CLIENT_ID,
    redirectUri: `${document.location.protocol}//${document.location.host}/sso/okta`,
    postLogoutRedirectUri: `${document.location.protocol}//${document.location.host}/sso/okta/logout`,
    tokenManager: { storageKey: 'lx-orion-token', storage: 'localStorage', autoRenew: true },
    storageManager: {
        token: { storageTypes: ['memory'] },
        cache: { storageTypes: ['memory'] },
        transaction: { storageTypes: ['sessionStorage', 'memory'] }, // sessionStorage used to mitigate error in OR-25633
    },
    services: {
        autoRenew: true,
        autoRemove: false,
    },
});

export default oktaAuth;
